var r=function(r){if(!r)return"";var e="",n=r.indexOf("?");return n>=0&&(e=r.slice(n+1)),e};export{r as getQuery};
